module.exports = {
	monday: 'Monday',
	tuesday: 'Tuesday',
	wednesday: 'Wednesday',
	thursday: 'Thursday',
	friday: 'Friday',
	saturday: 'Saturday',
	sunday: 'Sunday',
};



//////////////////
// WEBPACK FOOTER
// ../server/constants/daysOfTheWeek.js
// module id = 1196
// module chunks = 0